
import './App.scss';
import React , {useEffect, useState} from 'react'

function App() {

  const [data, setData] = useState([])
  let [city , setCity] = useState()
  const [prawda , setPrawda] = useState(false)
  let [temp , setTemp] = useState(0)

  const [selected , setSelected] = useState();
  

  
  useEffect( () => {
    fetch("https://danepubliczne.imgw.pl/api/data/synop")
    .then( response => response.json())
    .then( (data) => setData(data))
    .catch( (error) => console.error('error', error))

  } , [] )


 
  // const handleOnChange = (e) =>{

  //   const selectedElement = document.querySelector('.selectElement')
  //   console.log(selectedElement.value)
  //   setSelected(selectedElement.value)
  //   setPrawda(false)
  //   e.preventDefault()
  //   const valueInput = e.target.value
  //   const newArr = [...data]

  //   console.log(newArr)
    

  //   const foundCity = newArr.filter( (item)=> item.stacja.includes(valueInput))
    
  //     setCity(foundCity)
  //     setTemp(0)
    
  // }
  

    const handleClick = () => {

    
    setPrawda(true)
    // setTemp(city[0].temperatura)

   
   }

  const handleSelected = (e) => {

   const newArr = [...data]
   const foundCitySelected = newArr.filter( (item)=> item.stacja.includes(e.target.value))

   setCity(foundCitySelected)
   setPrawda(true)
   setTemp(foundCitySelected.temperatura)


  }


  return (
    <div className="App">
      
        <div className="weather-card">

            <h1>Sprawdź pogode w swoim mieście</h1>

            {/* <input placeholder="search your City..." onChange={handleOnChange}></input> */}
            {/* <button onClick={handleClick}>Chosse City</button> */}
            <select className='selectElement'  onChange={ (e) => handleSelected(e)}>
                  {data.map( (item,index) => {
                  
                  return(
                      
                      <option id="option" key={index} value={item.stacja}>{item.stacja} </option> 
                    
                  )
                })}
            </select>



            {prawda ?  city.map( (item) => {

                  return(
                    <div key={item.stacja}>
                      <h1>{item.stacja}</h1>
                      <p>{item.data_pomiaru}</p>
                      <h2>temperatura wynosi :</h2>
                      <h1 className='temperature'>{item.temperatura} C</h1>
                      <h3>cisnienie: {item.cisnienie}</h3>
                      <h3>Godzina pomiaru : {item.godzina_pomiaru}</h3>
                    

                    {item.temperatura > 4 ? <div className='temp' style={{backgroundColor:'red',borderRadius:'10px'}}><p>super pogoda</p> </div> : ""} 
                 {item.temperatura < 0 ? <div className='temp' style={{backgroundColor:'blue',borderRadius:'10px'}}><p>ubierz sie ciepło</p> </div> : ""} 
                  </div>
                  )}): "wpisz poprawna nazwe Miasta"}

                 


                
                  
        
        </div>
        
        
      
    </div>

    
  );

  

}

export default App;
